import { Component, Input, AfterViewInit, OnDestroy, ChangeDetectorRef, OnInit } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { Subject, merge } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

import { AppErrorMessagesService } from '../services/app-error-messages.service';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-error-messages',
    templateUrl: './app-error-messages.component.html',
    styleUrls: ['./app-error-messages.component.scss'],
    imports: [TranslateModule]
})
export class AppErrorMessagesComponent implements OnInit, OnDestroy {
  @Input() control: AbstractControl;

  @Input() showUntouchedErrors = false;

  errors: { key: string; translate: boolean; params: { [param: string]: any } }[] = [];

  public get showErrors(): boolean {
    if (!this.control) {
      return false;
    }
    return this.control.dirty || this.control.touched || (this.showUntouchedErrors && this.control.untouched);
  }

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(private readonly errorMessagesService: AppErrorMessagesService) {
  }

  ngOnInit() {
    merge(this.control.statusChanges)
      .pipe(
        takeUntil(this.unsubscribe),
        startWith(this.control.status)
      )
      .subscribe(() => {
        this.generateErrorMessages();
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private generateErrorMessages() {
    if (this.control.invalid) {
      this.errors = this.errorMessagesService.createMessages(this.control);
    } else {
      this.errors = [];
    }
  }
}
